"use client";
import { memo, useEffect } from "react";
import Image from "next/image";
import { easeInOut, motion } from "framer-motion";

const noop = () => {};

const bounceTransition = {
  repeat: Infinity,
  ease: easeInOut,
  duration: 1,
};

function SuitabilityTypingBubble({
  duration = 10000,
  onComplete = noop,
}: {
  duration?: number;
  onComplete?: () => void;
}) {
  useEffect(() => {
    const timeout = setTimeout(() => {
      onComplete();
    }, duration);

    return () => clearTimeout(timeout);
  }, [duration, onComplete]);

  return (
    <div className="flex items-start gap-2 overflow-hidden">
      <Image
        src="/next_assets/images/suitability-modal/chatbox-user-avatar.png"
        alt="Typing"
        width={40}
        height={40}
        className="rounded-full"
      />
      <motion.div
        className="bg-[#F0F2FF] p-2.5 rounded-xl flex items-center gap-2 w-15 justify-center"
        initial={{ maxWidth: 0, opacity: 0 }}
        animate={{ maxWidth: "fit-content", opacity: 1 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
      >
        {[0, 1, 2].map((i) => (
          <motion.div
            key={i}
            className="w-2.5 h-2.5 shrink-0 rounded-full bg-[#333]"
            animate={{ opacity: [0.3, 1, 0.3] }}
            transition={{ ...bounceTransition, delay: i * 0.2 }}
          />
        ))}
      </motion.div>
    </div>
  );
}

export default memo(SuitabilityTypingBubble);
